module.exports = __webpack_public_path__ + "img/icon-activity-call.234959ce.svg";